




























import { Component, Emit, Vue } from 'vue-property-decorator';
import { storeLinks } from '~/utils/app-config';

@Component({})
export default class MobileDownloadFixedFooter extends Vue {
  deviceType: string | null = null;

  mounted () {
    this.getDeviceType();
    this.$store.commit("SET_MOBILE_DOWNLOAD_BANNER_DISPLAY", true);
  }

  getDeviceType () {
    const userAgent = navigator.userAgent || navigator.vendor;

    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      this.deviceType = "iphone";
    } else {
      this.deviceType = "android";
    }
  }

  get downloadLink (): string {
    if (this.deviceType === "iphone") {
      return storeLinks.apple;
    } else {
      return storeLinks.google;
    }
  }

  @Emit('close-mobile-download-fixed-footer')
  closeMobileDownloadFixedFooter () {
    sessionStorage.setItem('mobileDownloadFixedFooterClosed', 'true');
    this.$store.commit("SET_MOBILE_DOWNLOAD_BANNER_DISPLAY", false);
  }
}
